export const MONITORING_QUEUE_ENTRY_DETAILS_MESSAGES = {
  NOT_FOUND: 'The monitoring queue entry details were not found',
};


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/monitoringQueueEntryDetailsMessages.js